
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Kontrakt } from "../../models/kontrakt-models";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class ChangeKontraktAffarsformCommand extends KontraktCommandBase {
    readonly affarsform: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ChangeKontraktAffarsformCommand";

    constructor(avtalGuid: string, kontrakt: Kontrakt) {
        super(avtalGuid, kontrakt.guid, ChangeKontraktAffarsformCommand.$type, CommandType.Replace);
        this.affarsform = kontrakt.affarsform;
    }
}
